import axios from "axios";

const getToken = () => {
  let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : localStorage.getItem('token');
  let refresh = sessionStorage.getItem('refresh') ? sessionStorage.getItem('refresh') : localStorage.getItem('refresh');
  return { token, refresh }
}

let isRefreshing = false;



const axiosClient = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  headers: {
    "content-type": "application/json",
    // "X-Forwarded-For": `${sessionStorage.getItem("ip")}`,
    authorization: `vinorsoft ${getToken().token}`,
  },
});
//"application/json"
// axios.defaults.headers = {
//   'Cache-Control': 'no-cache',
//   'Pragma': 'no-cache',
//   'Expires': '0',
// };
axiosClient.interceptors.request.use(async (config) => {
  const { token } = getToken();
  if (token) {
    config.headers.authorization = `vinorsoft ${token}`;
  }
  return config;
});
axiosClient.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      return response.data;
    }
    return response;
  },
  async (error) => {
    if (getToken().token && error?.response?.status === 401) {
      if (!isRefreshing) {
        isRefreshing = true;
        try {
          const res = await axios.post(
            `${process.env.REACT_APP_API_URL}authenticator/refreshToken/`,
            {
              refresh: getToken().refresh,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          sessionStorage.setItem("token", res.data.access);
          localStorage.setItem("token", res.data.access);
          // window.location.reload();
          error.config.headers.authorization = `vinorsoft ${getToken().token}`;
          isRefreshing = false;
          return axiosClient.request(error.config);
        } catch (error) {
          isRefreshing = false;
          if (error?.response?.status === 401) {

            window.location.replace('/login')
          }
          throw error;
        }
      } else {
        // Chờ đến khi token mới được cập nhật và gửi lại yêu cầu sau đó
        await new Promise((resolve) => {
          const intervalId = setInterval(() => {
            if (!isRefreshing) {
              clearInterval(intervalId);
              resolve();
            }
          }, 100);
        });
        return axiosClient.request(error.config);
      }
    }
    throw error;
  }
);
export default axiosClient;
